import { ButtonProps, Col, Popconfirm, Row, Table } from "antd";
import { TableProps } from "antd/lib/table";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import dataArrayHandle from "src/shared/function/dataArrayHandle";
import deleteFromObject from "src/shared/function/deleteFromObject";
import { queryParse } from "src/shared/function/queryParse";
import queryString from "src/shared/function/queryString";
import useRequest from "src/shared/hooks/useRequest";
import useSWR, { ConfigInterface, trigger } from "swr";
import { fetcherFn } from "swr/dist/types";
import { AlertC, ButtonC, CardC, ErrorC } from "..";
import useFilter from "../../hooks/useFilter";
import TableFilterC from "./TableFilter.Component";
interface deleteProps extends ButtonProps {
  api?: string;
  apiTrigger?: string;
}
interface editProps extends ButtonProps {
  route?: string;
}

interface TableComponentProps extends TableProps<any> {
  error?: any;
  isPagination?: boolean;
  totalCount?: number;
  hasTableFilter?: boolean;
  columnName?: string;
  api?: string;
  showOperation?: {
    deleteProps?: deleteProps;
    editProps?: editProps;
  };
  refreshColumns?: any;
  mustFields?: boolean;
  addFields?: string[];
  onRevalidate?: () => Promise<boolean>;
  ignoreSearchFields?: string[];
  columns: any[];
  getData?: Function;
  swrProps?: ConfigInterface<any, any, fetcherFn<any>>;
  initialSearch?: any;
  initCurrent?: number;
  initPageSize?: number;
}
const TabsComponent = (props: TableComponentProps) => {
  const {
    error,
    isPagination = true,
    totalCount,
    columns,
    hasTableFilter,
    columnName,
    showOperation,
    api,
    mustFields,
    refreshColumns,
    addFields = [],
    ignoreSearchFields = [],
    getData,
    swrProps,
    initialSearch,
    initCurrent,
    initPageSize,
  } = props;

  const { deleteProps, editProps } = showOperation || {};
  const { api: deleteApi, apiTrigger } = deleteProps || {};
  const { route: editRoute } = editProps || {};
  const {
    location: { search, state: locState },
    push,
  } = useHistory();
  const query = queryParse(search);

  const { onDelete, loading } = useRequest();
  const [newColumns, setNewColumns] = useState([]);

  // useEffect(() => {
  //   if (resetColumns) {
  //     setNewColumns([]);
  //   }
  // }, [resetColumns]);

  const apiCaller = (ApiBase?: string) => {
    const apiSearch = `${queryString({
      ...deleteFromObject(query, ["revalidate", ...ignoreSearchFields]),
      ...initialSearch,
      fields: [
        ...addFields,
        ...newColumns
          ?.filter((item: any) => item.show != false)
          .map((item: any) => item.dataIndex),
      ],
    })}`;
    let Api = `${ApiBase}${apiSearch.length ? `?${apiSearch}` : ""}`;
    if (api && newColumns.length) {
      if (mustFields) {
        if (apiSearch.includes("fields")) {
          return Api;
        } else {
          return null;
        }
      } else {
        return Api;
      }
    }
    return null;
  };

  var { data, isValidating, revalidate } = useSWR(apiCaller(api), {
    onSuccess: (data) => {
      getData && getData(data);
    },
    ...swrProps,
  });
  let locStates: any = locState;
  useEffect(() => {
    if (locStates?.revalidate) {
      revalidate().then(() => onFilter({}, { isAssign: true }));
    }
  }, [locStates?.revalidate]);

  const {
    onFilter,
    onPagination,
    pageSize: Take,
    current: Skip,
    onSorter,
    onTable,
  } = useFilter();
  const { t } = useTranslation();

  /* ---------------------------------- state --------------------------------- */

  useEffect(() => {
    const columnStorage = columnName && localStorage.getItem(columnName);
    let col = [];
    if (columnStorage) {
      const columnStorageParse: string[] = JSON.parse(columnStorage);
      col = _.compact(columns)?.map((item: any) =>
        columnStorageParse.includes(item.dataIndex)
          ? { ...item, show: true, align: "center" }
          : { ...item, show: false, align: "center" }
      ) as any;
    } else {
      col = _.compact(columns)?.map((item) => ({
        ...item,
        show: true,
        align: "center",
      })) as any;
    }

    setNewColumns(col);
  }, [JSON.stringify(columns), refreshColumns]);

  return !error ? (
    <>
      {hasTableFilter && (
        <TableFilterC
          columnName={columnName}
          newColumns={newColumns}
          //@ts-ignore
          setNewColumns={setNewColumns}
          exportApi={() => apiCaller(`${api}/export`)}
        />
      )}
      <CardC bodyStyle={{ paddingTop: 0, paddingRight: 0, paddingLeft: 0 }}>
        {swrProps?.refreshInterval && (
          <AlertC
            message={`هر ${
              swrProps?.refreshInterval / 1000
            } ثانیه به روز میشود.`}
          />
        )}
        <Table
          rowKey="id"
          loading={isValidating}
          onChange={(pagination, filters, sorter) =>
            onTable(pagination, filters, sorter)
          }
          bordered={false}
          size="small"
          scroll={{ x: "calc(600px + 40%)", y: "90vh" }}
          pagination={{
            // itemRender: itemRender,
            current: initCurrent || Skip ? Number(Skip) : 1,
            pageSize: initPageSize || Take ? Number(Take) : 10,
            // defaultPageSize: Number(pageSize),
            total: data ? data.totalCount : totalCount,
            showQuickJumper: true,
            position: ["bottomCenter"],
            responsive: true,
            showSizeChanger: true,
          }}
          dataSource={dataArrayHandle(data ? data.items : [])}
          {...props}
          columns={newColumns?.filter((item: any) => item.show != false)}
        />
      </CardC>
    </>
  ) : (
    //@ts-ignore
    <ErrorC error={error} />
  );
};

export default TabsComponent;
